import { render } from "./AseguradorForm.vue?vue&type=template&id=eefd85b8&scoped=true"
import script from "./AseguradorForm.vue?vue&type=script&lang=js"
export * from "./AseguradorForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=eefd85b8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eefd85b8"]])

export default __exports__